{
    "id": 42,
    "open": "2026-03-16T18:00:00+00:00",
    "close": "2026-03-16T18:45:00+00:00",
    "prequeue": 15,
    "queue": "https://sff-queue.netlify.app",
    "entry": "https://www.shetlandfolkfestival.com/queue",
    "home": "https://www.shetlandfolkfestival.com/",
    "event": "https://www.shetlandfolkfestival.com/tickets"
}
